import { Grid, Popconfirm } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledButton } from '../../lib/Antd/styledComponents';
import enResource from '../../locales/en/Resources.json';
import fiResource from '../../locales/fi/Resources.json';
import plResource from '../../locales/pl/Resources.json';
import svResource from '../../locales/sv/Resources.json';

const useBreakpoint = Grid.useBreakpoint;

export interface CancelButtonProps {
  disabled: boolean;
  cancelFunc: () => void;
}

export const CancelButton = ({ disabled, cancelFunc }: CancelButtonProps) => {
  const i18n = useTranslation()[1];
  i18n.addResources('en', 'geosecma-settings', enResource.settings);
  i18n.addResources('sv', 'geosecma-settings', svResource.settings);
  i18n.addResources('fi', 'geosecma-settings', fiResource.settings);
  i18n.addResources('pl', 'geosecma-settings', plResource.settings);
  const { t } = useTranslation('geosecma-settings');
  const screens = useBreakpoint();

  const onConfirm = () => {
    cancelFunc();
  };

  return (
    <Popconfirm
      title={t('changesWillBeLost')}
      onConfirm={onConfirm}
      okText={t('ok')}
      cancelText={t('cancel')}
      placement="top"
    >
      <StyledButton block={!screens.lg} data-testid="cancelEditsButton" disabled={disabled}>
        {t('cancel')}
      </StyledButton>
    </Popconfirm>
  );
};
